import {
  EmptyState,
  EmptyStateDescription,
  EmptyStateGraphic,
  EmptyStateTitle,
  Image,
} from '@customerio/pluma-components/react';
import warning from '@/assets/images/warn.svg';

export const NotFoundPage = () => {
  return (
    <EmptyState>
      <EmptyStateGraphic>
        <Image src={warning} width={80} height={80} role="presentation" />
      </EmptyStateGraphic>
      <EmptyStateTitle>Whoops!</EmptyStateTitle>
      <EmptyStateDescription>Sorry, but this page doesn't exist :(</EmptyStateDescription>
    </EmptyState>
  );
};
